import { FlexContainer, IconMessage, ReemaThemeV2 } from '@act/storybook';
import { ThemeProvider } from '@mui/material/styles';

type AppConfigLoadErrorProps = {
  /** User-facing detail from the failed client-config request. */
  message?: string;
};

/**
 * Shown when the portal cannot load `/client-config` from the API.
 * @param message - Optional error detail to display under the default copy.
 */
const AppConfigLoadError = ({ message }: AppConfigLoadErrorProps) => {
  return (
    <ThemeProvider theme={ReemaThemeV2.LIGHT_MODE}>
      <FlexContainer
        direction="column"
        alignItems="center"
        justifyContent="center"
        padding={4}
        width="100%"
        height="100vh"
      >
        <FlexContainer direction="column" alignItems="center" gap={2} maxWidth="480px">
          <IconMessage
            message="Unable to load application"
            subMessage={
              message ??
              'We could not reach the server to load configuration. Check your connection and try again.'
            }
            iconName="WarningCircle"
            iconColor="error"
          />
        </FlexContainer>
      </FlexContainer>
    </ThemeProvider>
  );
};

export default AppConfigLoadError;
